import { render, staticRenderFns } from "./PlayerControls.vue?vue&type=template&id=1a1f5b50&"
import script from "./PlayerControls.vue?vue&type=script&lang=js&"
export * from "./PlayerControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports